import argv from 'minimist-argv';
import config from '../config';
import detectBoard from './utils/detectBoard';
import parseHostPort from './utils/parseHostPort';

if (argv.port || argv.host) {
  console.warn('--port and --host are deprecated, use --address instead');
}

if (process.env.SERVER_HOST || process.env.SERVER_PORT) {
  console.warn(
    'env variables SERVER_HOST and SERVER_PORT are deprecated, use /etc/pooliot-client/config or --address instead',
  );
}

if (process.env.SERVER_ADDRESS) {
  console.warn('env variable SERVER_ADDRESS is deprecated, use /etc/pooliot-client/config instead');
}

if (process.env.WEB_PORT) {
  console.warn('env variable WEB_PORT is deprecated, use /etc/pooliot-client/config instead');
}

if (argv['web-port']) {
  console.warn('--web-port is deprecated, use /etc/pooliot-client/config instead');
}

if (process.env.USER_ID) {
  console.warn(
    'env variable USER_ID is deprecated, use /etc/pooliot-client/config or --token instead',
  );
}

if (argv['web-port']) {
  console.warn('--userId is deprecated, use --token instead');
}

if (process.env.PI_USER) {
  console.warn('env variable PI_USER is deprecated, use /etc/pooliot-client/config instead');
}

if (argv.piUser) {
  console.warn('--piUser is deprecated, use /etc/pooliot-client/config instead');
}

if (process.env.USER !== 'root' && process.env.USER) {
  console.warn('env variable USER is deprecated, use /etc/pooliot-client/config instead');
}

export const device = detectBoard();

export const serverAddress =
  process.env.SERVER_ADDRESS || argv.address || config.ADDRESS || 'https://pooliot.net:9310';
const [serverHost, serverPort] = parseHostPort(serverAddress);

export { serverHost, serverPort };

export const webPort = process.env.WEB_PORT || argv['web-port'] || config.WEB_PORT || 80;
export const token =
  process.env.TOKEN || argv.token || config.TOKEN || process.env.USER_ID || argv.userId;

const guessUser = () => {
  if (!device.user) throw new Error('Please provide USER');
  return device.user;
};

export const user =
  (process.env.USER !== 'root' && process.env.USER) ||
  process.env.PI_USER ||
  argv.piUser ||
  config.USER ||
  guessUser();

if (!serverAddress || serverAddress === ':') {
  // eslint-disable-next-line no-console
  console.log('WARNING: address is missing');
}

if (!token) {
  // eslint-disable-next-line no-console
  console.log('WARNING: userId is missing');
}
